import { CLASSES, classOf } from '../sim/defs';
import type { Ev, Sim } from '../sim/sim';
import { castKind } from './audio-logic';
export type Cue = { kind: string; x?: number; y?: number; gain?: number; important?: boolean; delay?: number; after?: string; cueKey?: string };
const shared = (kind: string, extra: Partial<Cue> = {}): Cue => ({ kind: `shared/${kind}`, ...extra });
/** Events only describe sounds. No random draws, commands or writes to the simulation. */
export function eventCues(e: Ev, sim: Sim, me: number): Cue[] {
  const faction = (p: number) => sim.players[p]?.faction ?? 'knights';
  const army = (p: number, kind: string, extra: Partial<Cue> = {}): Cue => ({ kind: `${faction(p)}/${kind}`, ...extra });
  switch (e.e) {
    case 'shot': {
      const siege = CLASSES[e.cls] === 'siege', lob = siege && classOf('siege', sim.faction(e.team)).kind === 'blast';
      return [army(e.team,siege ? 'siege' : 'ranged',{x:e.x0,y:e.y0,gain:0.5}),
        shared(siege ? 'siege_impact' : 'arrow_impact',{x:e.x1,y:e.y1,gain:0.45,delay:lob ? 0.9 : 0.35})];
    }
    case 'hit': return [army(e.team,'hit',{x:e.x,y:e.y,gain:0.45})];
    case 'spawn': return [shared('spawn',{x:sim.x[e.i],y:sim.y[e.i],gain:0.22})];
    case 'death': return CLASSES[e.cls] === 'hero' ? [] : [shared('defeat',{x:e.x,y:e.y,gain:0.35})];
    case 'heroDown': return [shared('defeat',{...(e.p === me ? {} : {x:e.x,y:e.y}),important:true})];
    case 'hero': return (sim.players[e.p]?.hero?.deaths ?? 0) > 0 ? [shared('hero_revive',{...(e.p === me ? {} : {x:sim.x[e.i],y:sim.y[e.i]}),important:true})] : [];
    case 'level': return e.p === me ? [shared('hero_levelup',{important:true})] : [];
    case 'cast': return [shared(castKind(sim.players[e.p].hero?.id ?? '',e.k),{x:e.x,y:e.y,important:true,gain:0.8})];
    case 'tier': return [army(e.p,'tierup',{...(e.p === me ? {} : {x:sim.bases[e.p].x,y:sim.bases[e.p].y}),important:true,after:`${faction(e.p)}/call`})];
    case 'baseHit': return [shared('building_hit',{x:sim.bases[e.p].x,y:sim.bases[e.p].y,gain:0.65})];
    case 'out': return [shared('building_fall',{x:sim.bases[e.p].x,y:sim.bases[e.p].y,important:true,after:'shared/place'}), ...(e.p === me ? [shared('defeat',{important:true,cueKey:'match-defeat'})] : [])];
    case 'phase': return [shared(e.name === 'final' ? 'final_warning' : 'gates_open',{important:true})];
    case 'win': return me < 0 || e.p === me ? [army(e.p,'win',{important:true,after:'shared/hop'})] : []; // loss already played at out
    case 'bossDown': return [shared('building_fall',{x:e.x,y:e.y,important:true})];
    case 'slam': return [shared('siege_impact',{x:e.x,y:e.y,gain:0.8})];
    default: return [];
  }
}
export function swingKind(cls: string) {
  return cls === 'spear' || cls === 'cavalry' || cls === 'elite' ? cls : cls === 'ram' ? 'siege' : 'swing';
}
